import React from 'react';
import classnames from 'classnames';
import Slide from '@material-ui/core/Slide';
import DefaultSnackbarComponent from '@material-ui/core/Snackbar';
import PropTypes from 'prop-types';

import AlertSnackbar from './components/AlertSnackbar';
import { orCondition } from '../../util/helpers';
import { snackbarPropType } from '../../types/snackbar';

export const SNACKBAR_TYPES = {
    ERROR: 'error',
};

const Snackbar = ({ theme, classes = {}, snackbarProps, onClose }) => {
    const { slide, slideDirection = 'up', type } = snackbarProps?.customization || {};

    const defaultSnackbarProps = {
        autoHideDuration: 5000,
        classes: {
            ...classes,
            root: classnames({
                [classes.root]: classes && !!classes.root,
                [theme.snackbar]: true,
            }),
        },
        ClickAwayListenerProps: {
            mouseEvent: false,
            touchEvent: false,
        },
        ...(slide ? {
            TransitionComponent: props => <Slide { ...props } direction={ slideDirection } timeout={ 500 } />,
        } : {}),
    };

    const mergedSnackbarProps = {
        ...defaultSnackbarProps,
        ...snackbarProps,
        onClose,
    };

    const SnackbarComponent = orCondition(
        [type === SNACKBAR_TYPES.ERROR, AlertSnackbar],
        [true, DefaultSnackbarComponent]
    );

    return (
        <SnackbarComponent { ...mergedSnackbarProps } />
    );
};

Snackbar.propTypes = {
    theme: PropTypes.shape({}),
    classes: PropTypes.string,
    snackbarProps: PropTypes.shape(snackbarPropType),
    onClose: PropTypes.func,
};

export default Snackbar;
